export default __webpack_public_path__ + "static/media/f_wdt_c_0.4e279cef.mp3";